module.exports = __webpack_public_path__ + "static/desktop/img/orders.d76d72fa.svg";